import React from "react";
import { Backdrop } from "@mui/material";
import { CircularProgress } from "@mui/material";
import { GeneralContextFunc } from "../Context/GeneralContex";

const Loader = () => {
  const { loader } = GeneralContextFunc();
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loader}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default Loader;
